import { EditBoxIcon } from '@common_components/icons/editBox.icon';
import { PlusIcon } from '@common_components/icons/plus.icon';
import { TrashIcon } from '@common_components/icons/trash.icon';
import React from 'react';
import ModalButton from '../buttons/modalButton.component';
import ModalButtonDelete from '../buttons/modalButtonDelete.component';
import ModalButtonCreateUpdate from '../buttons/modalButtonCreate.component';

interface ExtraButton {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  textColor?: string;
  bgColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  width?: string;
  disable?: boolean;
}

interface ModalFooterProps {
  tableId?: string;
  formValid?: boolean;
  showButtons?: boolean;
  onCreate: () => void;
  onUpdate?: () => void;
  onDelete?: () => void;
  extraButtons?: ExtraButton[];
  direction?: 'left' | 'center' | 'right'
}

const BottomModal: React.FC<ModalFooterProps> = ( {
  tableId,
  showButtons = true,
  formValid = true,
  onCreate,
  onUpdate,
  onDelete,
  extraButtons = [],
  direction = 'left'
} ) => {
  return (
    <div className="flex w-full flex-wrap items-center gap-3 border-t border-t-gray-200 bg-white-base px-5 py-2 font-semibold rounded-b-md">
      {showButtons && (
        <>
          <div className="flex w-full flex-wrap items-center gap-3">
            {onDelete && tableId && (
              <div className="shrink-0">
                <ModalButtonDelete
                  icon={<TrashIcon size={5} />}
                  onClick={onDelete}
                />
              </div>
            )}

            <div className={ `flex min-w-0 flex-1 flex-wrap items-center gap-2 ${ direction == 'right' ? 'justify-end' : direction == 'center' ? 'justify-center' : 'justify-start' }` }>
              {extraButtons.map( ( btn, i ) => {return (
                <ModalButton
                  key={i}
                  label={btn.label}
                  icon={btn.icon}
                  onClick={btn.onClick}
                  textColor={btn.textColor}
                  bgColor={btn.bgColor}
                  borderColor={btn.borderColor}
                  hoverBorderColor={btn.hoverBorderColor}
                  width={btn.width}
                  disable={btn.disable}
                />
              );} )}
            </div>
          </div>

          <div className="ml-auto shrink-0">
            <ModalButtonCreateUpdate
              iconCreate={<PlusIcon size={5} />}
              iconUpdate={<EditBoxIcon size={5} />}
              create={tableId ? false : true}
              onCreateClick={onCreate}
              onUpdateClick={onUpdate}
              disable={!formValid}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BottomModal;
